// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nNX4e","badges":"styles_badges__IGeA3"};